module.exports = __webpack_public_path__ + "static/media/A11.66d1ab0d.png";